module.exports = __webpack_public_path__ + "img/closedialogue.372b3d38.svg";